import * as CSS from 'csstype';
import styled from 'styled-components';
import {
  space,
  layout,
  color,
  typography,
  SpaceProps,
  LayoutProps,
  ColorProps,
  TypographyProps,
  variant,
  system,
} from 'styled-system';
import rem from '../../../utils/rem';

type Variants = {
  variant?: 'small' | 'medium' | 'body' | 'large' | 'xLarge';
};

type CustomProps = {
  whiteSpace?: CSS.Property.WhiteSpace;
  textOverflow?: CSS.Property.TextOverflow;
  wordWrap?: CSS.Property.WordWrap;
  textTransform?: CSS.Property.TextTransform;
};

type TTextProps = SpaceProps &
  LayoutProps &
  ColorProps &
  TypographyProps &
  CustomProps;

export type TextProps = TTextProps & Variants;

export const Text = styled.p<TextProps>`
  ${variant({
    variants: {
      small: {
        fontSize: 'size12',
        lineHeight: rem(17),
      },
      medium: {
        fontSize: 'size14',
        lineHeight: rem(24),
      },
      body: {
        fontSize: 'size16',
        lineHeight: rem(24),
      },
      large: {
        fontSize: 'size24',
        lineHeight: rem(33),
      },
    },
  })}
  margin-top: 0;
  margin-bottom: 0;
  ${space}
  ${layout}
  ${color}
  ${typography}
  ${system({
    whiteSpace: true,
    textOverflow: true,
    wordWrap: true,
    textTransform: true,
  })}
`;

Text.defaultProps = {
  variant: 'body',
  color: ['primary', 'primary'] as any,
  whiteSpace: 'pre-line',
};

export const Title = styled(Text)`
  font-weight: 600;
  ${variant({
    variants: {
      xLarge: {
        fontSize: rem(36),
        lineHeight: rem(49),
      },
    },
  })}
`;

Title.defaultProps = {
  variant: 'large',
};

export const Link = styled.a<TTextProps>`
  margin-top: 0;
  margin-bottom: 0;
  text-decoration: none;
  cursor: pointer;
  ${space}
  ${layout}
  ${color}
  ${typography}
`;
